import React, {useEffect, useRef, useState} from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import useMediaQuery from "@mui/material/useMediaQuery";
import Popper from "@mui/material/Popper";
import Fade from "@mui/material/Fade";
import Grid from "@mui/material/Grid";
import {css, Global} from "@emotion/react";
import Typography from "@mui/material/Typography";
import Fab from "@mui/material/Fab";
import Cancel from "@mui/icons-material/Cancel";
import Button from "@mui/material/Button";
import {Theme} from "@mui/system";
import SelectSettings from "./SelectSettings";
import ZoomSettings from "./ZoomSettings";
import {CheckBox, TextFields} from "@mui/icons-material";
import {TextField} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import DialogComp from "./DialogComponent";
import {texts} from "./Image";
import DialogCompButton from "./DialogComponentButtons";


export const formatter = new Intl.NumberFormat('ru-RU', {
  style: 'currency',
  currency: 'RUB',
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
  // These options are needed to round to whole numbers if that's what you want.
  //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

export default function PayComp({selectedCells}) {

  const [fio, setFio] = useState("");
  const [agreeFio, setAgreeFio] = useState(false);
  const [agree, setAgree] = useState(false);
  const [goPay, setGoPay] = useState(false);

  function save(){

    let data = {
      selected: JSON.stringify(selectedCells),
      fio: fio
    }

    let form = new URLSearchParams(data);

    fetch(process.env.REACT_APP_HOST_BACK + "?save=true", {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/x-www-form-urlencoded'},
      // @ts-ignore
      body: form
    }).then((response) => {
      return response.json();
    }).then((data) => {
      if(data.success === true){
        window.open(data.payUrl, '_blank', 'noreferrer')
        setGoPay(true)
      }
    });
  }

  return <Box>

    <FormControlLabel
      sx={{m: 0, mr: 1, mb: 2, width: '100%', justifyContent: "space-between"}}
      labelPlacement={"start"}
      color={"info"}
      control={<Checkbox checked={agreeFio} sx={{color: "#fff", transform: "scale(2)"}} color={"info"} onChange={
        (e)=>{setAgreeFio(e.target.checked)}
      }/>
      }
      label={<Typography variant={"h4"} sx={{fontWeight: "bold"}} color={"white"}>
        Оставить моё имя в истории</Typography> }
    />
      <TextField
        variant={"outlined"}
        disabled={!agreeFio}
        fullWidth
        color={"info"}
        value={fio}
        onChange={(e)=>{setFio(e.target.value)}}
        label={"ФИО"}
        InputLabelProps={{sx: {color: "#fff", lineHeight: "2.4em" }}}
        sx={{ fieldset: { borderColor: '#fff' }, input: {color: "#fff", fontSize: "150%"},
          "& .MuiOutlinedInput-root:hover": {
            "& > fieldset": {
              borderColor: "#fff",
              color: "#fff"
            }
          },  "& .MuiOutlinedInput-root.Mui-disabled:hover": {
            "& > fieldset": {
              borderColor: "#777"
            }
          }
          }}
      />

      <FormControlLabel
        sx={{m: 0, mr: 1, mt: 2}}
        labelPlacement={"start"}
        color={"info"}
        control={<Checkbox checked={agree} sx={{color: "#fff", transform: "scale(2)"}} color={"info"} onChange={
          (e)=>{setAgree(e.target.checked)}
        }/>
        }
        label={<Typography variant={"h5"} sx={{fontWeight: "bold"}} color={"white"}>
          С Договором о добровольном пожертвовании
          и Политикой конфиденциальности ознакомлен.
          Разрешаю обработку персональных данных.</Typography> }
      />

      <Box mt={3}>
        <Button onClick={()=>{agree && Object.keys(selectedCells).length > 0 && save()}} color={"secondary"} disabled={!agree || Object.keys(selectedCells).length === 0 } sx={{borderRadius: 6}} fullWidth size={"large"} variant={"contained"}>
          <Typography variant={"h4"}>Совершить платёж</Typography>
        </Button>

      </Box>


    <DialogCompButton head={"Благодарим за участие"} text={
      <Box>
        <Typography variant={"h5"}>Благодарим за ваш вклад в сохранение наследия.</Typography>
        <Typography>
          Ваше имя навсегда войдёт в историю дома-музея семьи Шишкиных.
          После того как платёж будет проведён, выбранные ячейки будут закреплены за вами.
          Спасибо!
        </Typography>

      </Box>

    } open={goPay} setOpen={setGoPay}/>

    </Box>


}





